import React from "react";
import { BrowserRouter, Routes, useLocation } from "react-router-dom";
import { NavigationTracker } from "@/components/NavigationTracker";
import { MainRoutes } from "./mainRoutes";
import {
  dismissGooglePaySheet,
  installPaymentRequestCapture,
} from "@/utils/googlePaySheet";

installPaymentRequestCapture();

function ScrollToTop() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash]);
  return null;
}

function GooglePayRouteCleanup() {
  const location = useLocation();
  const didMountRef = React.useRef(false);

  React.useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    void dismissGooglePaySheet();
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export function AppRouter() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <GooglePayRouteCleanup />
      <NavigationTracker />
      <Routes>{MainRoutes()}</Routes>
    </BrowserRouter>
  );
}
